import React from "react";
import { Card } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import DiscoverPriorityTable from "./DiscoverPriorityTable";

export default function DiscoverPriorityList() {
  return (
    <div>
      <PageTitle
        activeMenu="Discover Priority"
        motherMenu="User Management"
      />
      <Card>
        <Card.Body>
          <div className="default-tab">
            <DiscoverPriorityTable />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
